import React from 'react';

import VenueRoomDetails from './component';

export default React.memo(VenueRoomDetails);
